import React, { useEffect } from 'react';
import { Box, Divider, Grid } from '@mui/material';
import { ITipo_Indice_Documento } from '../../services/api/tipo_indice/Tipo_Indice_Service';
import { IdComponente, TIdComponente } from './IdComponente';
import { useValoresIndices } from './UseValoresIndices';
import { registroDeCampos } from './campos';

interface IIndicesCadastroProps {
    rowsAlterarValorIndice: Omit<ITipo_Indice_Documento, 'idTipo'>[];
    aoSalvar?: () => void;
    onValoresAlterarChange: (valores: string[]) => void;
    reset?: boolean;
    initialValues?: string[];
    /** Token opcional: ao mudar, força um novo semeio a partir de `initialValues` mesmo com as mesmas `rows` (ex.: trocou de documento). */
    initialValuesKey?: string | number;
    somenteLeitura?: boolean;
    /** Acrescenta a opção "Nenhum" em Radio/Select, já semeada como valor inicial (telas de filtro/pesquisa). */
    comOpcaoNenhumEmRadioESelect?: boolean;
    valorOpcaoNenhum?: string;
    /** Insere um divisor visual a cada N campos (ex.: repetição dos mesmos índices por etiqueta de caixa). */
    quebrarEmBlocosDeTamanho?: number;
}

export const IndicesCadastro = ({
    rowsAlterarValorIndice,
    aoSalvar,
    onValoresAlterarChange,
    reset,
    initialValues,
    initialValuesKey,
    somenteLeitura = false,
    comOpcaoNenhumEmRadioESelect = false,
    valorOpcaoNenhum = 'nenhum',
    quebrarEmBlocosDeTamanho,
}: IIndicesCadastroProps) => {
    const valorInicialPorIndice = (index: number): string | undefined => {
        if (!comOpcaoNenhumEmRadioESelect) return undefined;

        const idComponente = rowsAlterarValorIndice[index]?.idComponente;
        if (idComponente === IdComponente.RADIO || idComponente === IdComponente.SELECT) {
            return valorOpcaoNenhum;
        }

        return undefined;
    };

    const { valores: valoresAlterar, setValor } = useValoresIndices(rowsAlterarValorIndice, {
        reset,
        initialValues,
        initialValuesKey,
        valorInicialPorIndice,
    });

    useEffect(() => {
        onValoresAlterarChange(valoresAlterar);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valoresAlterar]);

    return (
        <Grid container direction="column" padding={2} spacing={2}>
            <Grid container item direction="row" spacing={2}>
                {rowsAlterarValorIndice.map((item, index) => {
                    const Campo = registroDeCampos[item.idComponente as TIdComponente];
                    if (!Campo) return null;

                    const quebra = !!quebrarEmBlocosDeTamanho && index > 0 && index % quebrarEmBlocosDeTamanho === 0;

                    return (
                        <React.Fragment key={item.idIndice}>
                            {quebra && (
                                <Box width="100%" display="block">
                                    <br />
                                    <Divider />
                                </Box>
                            )}
                            <Campo
                                indice={item}
                                valor={valoresAlterar[index] ?? ''}
                                disabled={somenteLeitura}
                                onChange={(novoValor) => {
                                    if (!somenteLeitura) setValor(index, novoValor);
                                }}
                                onEnterKeyDown={aoSalvar}
                                comOpcaoNenhum={comOpcaoNenhumEmRadioESelect}
                                valorOpcaoNenhum={valorOpcaoNenhum}
                            />
                        </React.Fragment>
                    );
                })}
            </Grid>
        </Grid>
    );
};
